export default __webpack_public_path__ + "static/media/no-image.1bcaf704.png";